export default __webpack_public_path__ + "fonts/email-updated.svg";